import styles from './styles.module.scss'
import responsiveStyles from './responsive-styles.module.scss'
import { Wrapper } from '../../../../reusable'
import { useState } from 'react'
import logo from '../../../../../assets/sentinel-logo.png'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import shieldIcon from '../../../../../assets/shieldtick.svg'

export function MailReferralHeader() {
    const [clientName, setClientName] = useState<String>('')
    const [displayMenu, setDisplayMenu] = useState<Boolean>(false)
    const { token } = useParams()
    const navigate = useNavigate()

    const scrollToFaqs = () => {
        setDisplayMenu(false)
        let faqs = document.getElementsByClassName('faq-elem')
        if (faqs.length > 0) {
            faqs[0].scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' })
        } else {
            console.log('could not find the FAQS')
            navigate('/#faqs')
            const faqs = document.getElementsByClassName('faq-elem')
            if (faqs.length > 0) {
                faqs[0].scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' })
            }
        }
    }

    const toggleMenu = () => {
        console.log('TOGGLE....', displayMenu)
        setDisplayMenu(!displayMenu)
    }
    return (
        <header className={`${styles.header}  ${responsiveStyles.header} `}>
            <Wrapper>
                <div className={`${styles.innerHeader} ${responsiveStyles.innerHeader} `}>
                    <div className={`${styles.logo} ${responsiveStyles.logo} `}>
                        <img src={logo} alt="Sentinel Logo" />
                    </div>{' '}
                    <div className={`${styles.sslBadge} ${responsiveStyles.sslBadge} `}>
                        <img src={shieldIcon} alt="Secure SSL" />
                        <span className={styles.desktopText}>Data encrypted via secure protocol</span>
                    </div>
                </div>
            </Wrapper>
        </header>
    )
}
